import { Injectable } from '@angular/core';
import { CanActivate, CanLoad, Router, UrlTree } from '@angular/router';
import { environment } from 'src/environments/environment';

/** True when the release notes page is switched on for this build (environment.releaseNotesEnabled). */
export function isReleaseNotesEnabled(): boolean {
  return (environment as unknown as { releaseNotesEnabled?: boolean }).releaseNotesEnabled === true;
}

/**
 * Keeps /release-notes unreachable (redirects home) on builds where the page is
 * switched off, e.g. production until the page is meant to go live.
 */
@Injectable({ providedIn: 'root' })
export class ReleaseNotesEnabledGuard implements CanActivate, CanLoad {
  constructor(private router: Router) {}

  canActivate(): boolean | UrlTree {
    return this.check();
  }

  canLoad(): boolean | UrlTree {
    return this.check();
  }

  private check(): boolean | UrlTree {
    return isReleaseNotesEnabled() ? true : this.router.parseUrl('/');
  }
}
